import { Modal as NDSModal } from "@nulogy/components";
import React from "react";

export default function Modal({ children, ...modalProps }) {
  return (
    <NDSModal ariaHideApp={false} overlayClassName="transparent-modal-overlay" {...modalProps}>
      {children}
    </NDSModal>
  );
}
